<div class="badge-container" (click)="badgeClick()">
  <mat-icon [svgIcon]="badge.icon" [matBadgeColor]="color" [matBadge]="badge.count"></mat-icon>
  <p>
    {{ badge.text }}
  </p>
</div>
